import { throwErrorMsg } from "../../utils/throwErrorMsg"

export function registerNativeAPI(max: any) {
  max.register("fn", `__api__.*`, function () {
    throwErrorMsg("__api__")
  })
}
